import React, { useEffect } from 'react';
import * as yup from 'yup';
import { Drawer } from 'antd';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { StyledButton, StyledFormItem, StyledInput } from '../../Styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { green, purple } from './constants';

const englishRegex = /^[A-Z a-z]+$/;

const schema = yup.object().shape({
  membershipNumber: yup.string().length(10).required(),
  firstName: yup.string().matches(englishRegex).required(),
  lastName: yup.string().matches(englishRegex).required()
});

export default function AsiaMilesDrawer(props) {
  const { initValue, onClose, open, bannerUrl, onSubmit: _onSubmit } = props;
  const { register, handleSubmit, errors, control, formState } = useForm({
    defaultValues: initValue,
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });
  const { t } = useTranslation();

  useEffect(() => {
    register('membershipNumber');
    register('firstName');
    register('lastName');
  }, []);

  const onSubmit = data => {
    _onSubmit(data);
    onClose();
  };
  return (
    <Drawer
      visible={open}
      onClose={onClose}
      placement={'bottom'}
      drawerStyle={{ height: '100vh' }}
      bodyStyle={{ display: 'flex' }}
      height={'100vh'}
      style={{
        position: 'fixed',
        width: '100vw',
        margin: 0,
        backgroundColor: 'white',
        zIndex: 1
      }}>
      <div className={'flex-container row flex-1 flex-center'}>
        <div
          className={'flex-container col center flex-center'}
          style={{ maxWidth: 375 }}>
          <div className={'flex-container col'}>
            <img
              className="campaign-img"
              src={bannerUrl}
              alt=""
              style={{ maxWidth: '40%', marginBottom: 20 }}
            />
            <span style={{ fontSize: 20 }}>
              {t('campaigns.asia_miles.drawer.title')}
            </span>
            <span style={{ color: green, fontSize: 12 }}>
              {t('campaigns.asia_miles.drawer.call_for_action')}
            </span>
            <div style={{ paddingBottom: 20 }} />
          </div>
          <div className={'m-b-10'} style={{ alignSelf: 'stretch' }}>
            <div className={'m-b-10'}>
              {t('campaigns.asia_miles.drawer.input_label') + ' *'}
            </div>
            <Controller
              name={'membershipNumber'}
              control={control}
              render={({ onChange, value, onBlur }) => {
                return (
                  <StyledFormItem
                    validateStatus={errors['membershipNumber'] ? 'error' : null}
                    help={
                      errors['membershipNumber']
                        ? t(
                            'campaigns.asia_miles.drawer.validation_message.member_no_length'
                          )
                        : ''
                    }>
                    <StyledInput
                      size="large"
                      value={value}
                      onChange={e => {
                        onChange(e.target.value);
                      }}
                      onBlur={onBlur}
                      placeholder={
                        t('campaigns.asia_miles.drawer.eg') + '56789 98765'
                      }
                      maxLength={'10'}
                    />
                  </StyledFormItem>
                );
              }}
            />
          </div>
          <div
            className={'m-b-20'}
            style={{
              display: 'flex',
              alignSelf: 'stretch',
              justifyContent: 'space-between'
            }}>
            <div>
              <div className={'m-b-10'}>
                {t('campaigns.asia_miles.drawer.last_name_label') + ' *'}
              </div>
              <Controller
                name={'lastName'}
                control={control}
                render={({ onChange, value, onBlur }) => {
                  return (
                    <StyledFormItem
                      validateStatus={errors['lastName'] ? 'error' : null}
                      help={
                        errors['lastName']
                          ? t(
                              'campaigns.asia_miles.drawer.validation_message.english_only'
                            )
                          : ''
                      }>
                      <StyledInput
                        size="large"
                        value={value}
                        onChange={e => {
                          onChange(e.target.value);
                        }}
                        onBlur={onBlur}
                        placeholder={''}
                      />
                    </StyledFormItem>
                  );
                }}
              />
            </div>
            <div>
              <div className={'m-b-10'}>
                {t('campaigns.asia_miles.drawer.first_name_label') + ' *'}
              </div>
              <Controller
                name={'firstName'}
                control={control}
                render={({ onChange, value, onBlur }) => {
                  return (
                    <StyledFormItem
                      validateStatus={errors['firstName'] ? 'error' : null}
                      help={
                        errors['firstName']
                          ? t(
                              'campaigns.asia_miles.drawer.validation_message.english_only'
                            )
                          : ''
                      }>
                      <StyledInput
                        size="large"
                        value={value}
                        onChange={e => {
                          onChange(e.target.value);
                        }}
                        onBlur={onBlur}
                        placeholder={''}
                      />
                    </StyledFormItem>
                  );
                }}
              />
            </div>
          </div>
          <StyledButton
            className={'ant-btn-primary m-b-20'}
            onClick={handleSubmit(onSubmit)}
            disabled={
              Object.keys(errors).length !== 0 ||
              !['membershipNumber', 'firstName', 'lastName']
                .map(
                  k =>
                    formState.dirtyFields[k] ||
                    formState.touched[k] ||
                    initValue[k]
                )
                .reduce((a, b) => a && b, true)
            }>
            {t('campaigns.asia_miles.drawer.register_button')}
          </StyledButton>
          <span
            style={{ color: green, textAlign: 'center' }}
            className={'m-b-20'}>
            {t('campaigns.asia_miles.drawer.terms_and_services')}
          </span>
          <span style={{ color: purple }}>
            <a target="_blank" href={t('key') === 'en' ? 'https://spaceship.hk/en/offers/asiamiles' : 'https://spaceship.hk/offers/asiamiles'}>
              {t('campaigns.asia_miles.drawer.external_link') + ' '}
              <FontAwesomeIcon icon={'external-link-alt'} />
            </a>
          </span>
        </div>
      </div>
    </Drawer>
  );
}
